import * as yup from "yup";
import { validationNotEmpty, validationStringSelect } from "./defaultValidations";

export default yup.object({
  policyName: validationStringSelect("Policy Name for Detokenize"),
  policyMaskName: validationStringSelect("Policy Name for Masking"),
  plaintext: validationNotEmpty("Tokenized Data"),
});
